import { type ModalProps, Stack } from "@mantine/core"
import { useModal } from "@/hooks"
import { AppTitle } from ".."

export function useAppModal(props?: Partial<ModalProps>) {
  const { open, ...modalProps } = useModal(props || {})
  return {
    ...modalProps,
    open: (newProps?: Partial<ModalProps>) => {
      const activeProps = { ...props, ...newProps }
      return open({
        size: "auto",
        title: <AppTitle>{activeProps.title}</AppTitle>,
        ...activeProps,
      })
    },
  }
}

export function useEditModal(props?: Partial<ModalProps>) {
  const { open, ...modalProps } = useAppModal(props)
  return {
    ...modalProps,
    open: (newProps?: Partial<ModalProps>) => {
      const activeProps = { ...props, ...newProps }
      return open({
        ...activeProps,
        children: <Stack>{activeProps?.children}</Stack>,
      })
    },
  }
}
